exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "nav {\n\theight: 90px!important;\n}\n\n.modaldisplay {\n    display: block !important;\n}\n\n#passmodal input {\n    border: none;\n    background-color: transparent;\n    border-bottom: 2px solid black;\n    width: calc(100% - 2em);\n}\n\n#passmodal .button {\n    display: inline-block;\n    width: 4em;\n    float: right;\n    cursor: pointer;\n    margin-left: 1em;\n    background-color: rgb(200, 200, 200);\n    color: white;\n    border-radius: 4px;\n}\n\ninput, button:focus {\n    outline: none;\n}\n\n#passmodal {\n    text-align: center;\n    padding: 0 2em 2em 2em;\n}\n\n.passmodal-content {\n    width: 60%;\n    padding: 0 2em 2em 2em;\n}\n\n.wrapper {\n    margin: 0 20%;\n    width: 60%;\n    padding: 1em;\n    border: 1px solid black;\n}\n\n#yourModal {\n    display: block;\n}\n\n@media only screen and (max-width: 600px) {\n\tnav {\n\t\theight: 60px!important;\n\t}\n\t\n\tnav img {\n\t\tdisplay: none;\n\t}\n\n    .passmodal-content {\n        width: 80%;\n        padding: 0 2em 2em 2em;\n    }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = 0